export function coursesListSelector(state) {
  const ids = coursesListStateSelector(state).items
  return ids.map((id) => state.entities.courses.short[id])
}

export function coursesListStateSelector(state) {
  return state.local.courses.list
}
